import { editorLocalization } from "survey-creator-core";

var portugueseTranslation = {
  //survey templates
  survey: {
    edit: "Editar",
    dropQuestion: "Por favor arraste uma pergunta aqui.",
    copy: "Copiar",
    addToToolbox: "Adicionar à toolbox",
    deletePanel: "Remover Painel",
    deleteQuestion: "Remover Pergunta",
    convertTo: "Converter para",
    drag: "Arrastar elemento"
  },
  //questionTypes
  qt: {
    default: "Default",
    checkbox: "Checkbox",
    comment: "Comentário",
    imagepicker: "Selecionador de imagem",
    dropdown: "Dropdown",
    file: "Arquivo",
    html: "Html",
    matrix: "Matriz (opção única)",
    matrixdropdown: "Matriz (multiplas opções)",
    matrixdynamic: "Matriz (linhas dinâmicas)",
    multipletext: "Texto múltiplo",
    panel: "Painel",
    paneldynamic: "Painel (painéis dinâmicos)",
    radiogroup: "Radiogroup",
    rating: "Rating",
    text: "Texto único",
    boolean: "Boleano",
    expression: "Expressão"
  },
  //Strings in Editor
  ed: {
    defaultLocale: "Default ({0})",
    survey: "Pesquisa",
    settings: "Configurações da Pesquisa",
    editSurvey: "Editar Pesquisa",
    addNewPage: "Adicionar Nova Página",
    moveRight: "Role para direita",
    moveLeft: "Role para esquerda",
    deletePage: "Deletar Página",
    editPage: "Editar Página",
    edit: "Editar",
    newPageName: "página",
    newQuestionName: "pergunta",
    newPanelName: "painel",
    testSurvey: "Testar pesquisa",
    testSurveyAgain: "Testar pesquisa novamente",
    testSurveyWidth: "Tamanho do pesquisa: ",
    embedSurvey: "Incorporar Pesquisa",
    translation: "Tradução",
    saveSurvey: "Salvar Pesquisa",
    designer: "Designer de Pesquisa",
    jsonEditor: "Editor de JSON",
    undo: "Desfazer",
    redo: "Refazer",
    options: "Opções",
    generateValidJSON: "Gerar JSON válido",
    generateReadableJSON: "Gerar JSON legível",
    toolbox: "Toolbox",
    toolboxGeneralCategory: "Geral",
    delSelObject: "Apagar objeto selecionado",
    editSelObject: "Editar objeto selecionado",
    correctJSON: "Por favor corrija o JSON.",
    surveyResults: "Resultado da pesquisa: ",
    surveyResultsTable: "Como Tabela",
    surveyResultsJson: "Como JSON",
    resultsTitle: "Título da Pergunta",
    resultsName: "Nome da Pergunta",
    resultsValue: "Valor da Resposta",
    resultsDisplayValue: "Mostrar Valor",
    modified: "Modificado",
    saving: "Salvando",
    saved: "Salvo",
    saveError: "Erro! Conteúdo do editor não foi salvo.",
    translationAddLanguage: "Selecione o idioma para traduzir",
    translationShowAllStrings: "Mostrar todas strings",
    translationShowAllPages: "Mostrar todas páginas",
    translationNoStrings: "Nenhuma string para traduzir. Por favor, altere o filtro.",
    translationExportToSCVButton: "Exportar para CSV",
    translationImportFromSCVButton: "Importar de CSV",
    translationMergeLocaleWithDefault: "Combinar {0} com o idioma default"
  },
  //Property names in table headers
  pel: {
    isRequired: "Obrigatório?"
  },
  //Property Editors
  pe: {
    apply: "Aplicar",
    ok: "OK",
    cancel: "Cancelar",
    reset: "Limpar",
    close: "Fechar",
    delete: "Apagar",
    addNew: "Adicionar Novo",
    addItem: "Clique para adicionar um item...",
    removeAll: "Remover Todos",
    edit: "Editar",
    itemValueEdit: "Visível Se",
    editChoices: "Editar Opções",
    move: "Mover",
    empty: "<vazio>",
    notEmpty: "<editar valor>",
    fastEntry: "Entrada Rápida",
    formEntry: "Entrada com formulário",
    testService: "Testar o serviço",
    conditionSelectQuestion: "Selecionar pergunta...",
    conditionValueQuestionTitle: "Por favor, entre/selecione o valor",
    conditionButtonAdd: "Add",
    conditionButtonReplace: "Substituir",
    conditionHelp:
      "Por favor, entre com uma expressão boleana. Deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' ou ({pergunta2} * {pergunta4} > 20 e {pergunta3} < 5)",
    expressionHelp:
      "Por favor informe uma expressão boleana. Ela deve retornar verdadeiro para manter a pergunta/página visível. Por exemplo: {´pergunta1} = 'valor1' or ({pergunta2} = 3 and {pergunta3} < 5)",
    aceEditorHelp: "Pressione ctrl+space para autocompletar",
    aceEditorRowTitle: "Linha atual",
    aceEditorPanelTitle: "Painel atual",
    showMore: "Para mais detalhes, por favor visite a documentação",
    conditionShowMoreUrl:
      "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
    assistantTitle: "Perguntas disponíveis:",
    cellsEmptyRowsColumns: "Deve haver ao menos uma coluna ou linha",

    propertyIsEmpty: "Por favor informe um valor na propriedade",
    value: "Valor",
    text: "Texto",
    rowid: "ID da Linha",
    imageLink: "Link da Imagem",
    columnEdit: "Editar coluna: {0}",
    itemEdit: "Editar item: {0}",

    url: "URL",
    path: "Caminho",
    valueName: "Nome do valor",
    titleName: "Nome do título",

    showOtherItem: "Tem item 'outros'",
    otherText: "Texto do item 'outros'",
    name: "Nome",
    title: "Título",
    cellType: "Tipo de célula",
    colCount: "Contagem de células",
    choicesOrder: "Selecione a ordem das alternativas",
    visible: "É visível?",
    isRequired: "É obrigatório?",
    startWithNewLine: "Começa com uma nova linha?",
    rows: "Contagem de linhas",
    placeholder: "Texto de referência",
    showPreview: "Mostra pré-visualização de imagem?",
    storeDataAsText: "Gravar conteúdo de arquivo no resultado JSON como texto",
    maxSize: "Tamanho máximo de arquivo em bytes",
    imageHeight: "Altura da imagem",
    imageWidth: "Largura da imagem",
    rowCount: "Contagem de linhas",
    columnLayout: "Layout das colunas",
    addRowLocation: "Localização do botão de adicionar linha",
    addRowText: "Texto do botão para adicionar linhas",
    removeRowText: "Texto do botão para remover linhas",
    minRateDescription: "Descrição de qualificação mínima",
    maxRateDescription: "Descrição de qualificação máxima",
    inputType: "Tipo de entrada",
    optionsCaption: "Título de opção",
    defaultValue: "Valor default",
    cellsDefaultRow: "Texto default das células",

    surveyEditorTitle: "Editar configurações da pesquisa",
    qEditorTitle: "Editar pergunta: {0}",

    maxLength: "Tamanho máximo",

    //survey
    showTitle: "Mostrar/ocultar título",
    locale: "Idioma default",
    mode: "Modo (editável/somente leitura)",
    clearInvisibleValues: "Limpar valores invisíveis",
    cookieName: "Nome do cookie (para desativar rode a pesquisa duas vezes localmente)",
    sendResultOnPageNext: "Enviar resultado da pesquisa na página seguinte",
    storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",
    showPageTitles: "Mostrar título da página",
    showPageNumbers: "Mostrar número da página",
    pagePrevText: "Texto para botão de página anterior",
    pageNextText: "Texto para botão de página seguinte",
    completeText: "Texto para botão de completar",
    startSurveyText: "Texto para botão de começar",
    showNavigationButtons: "Mostrar botões de navegação (navegação default)",
    showPrevButton: "Mostrar botão de voltar (usuário pode retornar para página anterior)",
    firstPageIsStarted: "Primeira página da pesquisa é a página de início.",
    showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
    goNextPageAutomatic:
      "Ao responder todas as perguntas, ir automaticamente para a próxima página",
    showProgressBar: "Mostrar barra de progresso",
    questionTitleLocation: "Localização do título da pergunta",
    requiredText: "Símbolo(s) para perguntas obrigatórias",
    questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
    showQuestionNumbers: "Mostrar número das perguntas",
    questionTitleTemplate:
      "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
    questionErrorLocation: "Localização do erro da pergunta",
    focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta ao trocar de página",
    questionsOrder: "Ordenar elementos na página",
    maxTimeToFinish: "Tempo máximo para finalizar pesquisa",
    maxTimeToFinishPage: "Tempo máximo para finalizar página da pesquisa",
    showTimerPanel: "Mostrar o painel de cronômetro",
    showTimerPanelMode: "Mostrar painel de modo de cronômetro",
    renderMode: "Modo de renderização",
    allowAddPanel: "Permitir adicionar painel",
    allowRemovePanel: "Permitir remover painel",
    panelAddText: "Texto de adicionar painel",
    panelRemoveText: "Texto de remover painel",
    isSinglePage: "Mostrar todos elementos em uma página",

    tabs: {
      general: "Geral",
      fileOptions: "Opções",
      html: "Editor Html",
      columns: "Colunas",
      rows: "Linhas",
      choices: "Opções",
      items: "Itens",
      visibleIf: "Visível se",
      enableIf: "Habilitar se",
      requiredIf: "Obrigatório se",
      rateValues: "Valores de qualificação",
      choicesByUrl: "Opções com origem na Web",
      matrixChoices: "Opções padrão",
      multipleTextItems: "Entradas de texto",
      validators: "Validadores",
      navigation: "Navegação",
      question: "Pergunta",
      completedHtml: "Completo Html",
      loadingHtml: "Carregando Html",
      timer: "Cronômetro/Quiz",
      triggers: "Triggers",
      templateTitle: "Título do template"
    },
    editProperty: "Editar propriedade '{0}'",
    items: "Items",

    enterNewValue: "Por favor, informe o valor.",
    noquestions: "Não há nenhuma pergunta na pesquisa.",
    createtrigger: "Por favor, crie um gatilho",
    triggerOn: "Ligado ",
    triggerMakePagesVisible: "Tornar páginas visíveis:",
    triggerMakeQuestionsVisible: "Tornar perguntas visíves:",
    triggerCompleteText: "Completar a pesquisa se obtiver êxito.",
    triggerNotSet: "O gatilho não está definido",
    triggerRunIf: "Executar se",
    triggerSetToName: "Mudar o valor de: ",
    triggerFromName: "Copiar valor de: ",
    triggerRunExpression: "Rodar essa expressão:",
    triggerSetValue: "para: ",
    triggerIsVariable: "Não colocar a variável no resultado da pesquisa."
  },
  //Property values
  pv: {
    true: "verdadeiro",
    false: "falso",
    inherit: "inherit",
    show: "mostrar",
    hide: "ocultar",
    default: "default",
    initial: "inicial",
    random: "aleatório",
    collapsed: "colapsado",
    expanded: "expandido",
    none: "nenhum",
    asc: "ascendente",
    desc: "descendente",
    indeterminate: "indeterminado",
    decimal: "decimal",
    currency: "moeda",
    percent: "percentagem",
    firstExpanded: "primeiro expandido",
    off: "desligado",
    onPanel: "no painel",
    onSurvey: "na pesquisa",
    list: "lista",
    progressTop: "progresso superior",
    progressBottom: "progresso inferior",
    progressTopBottom: "progresso superior inferior",
    horizontal: "horizontal",
    vertical: "vertical",
    top: "superior",
    bottom: "inferior",
    topBottom: "superior and bottom",
    left: "esquerda",
    color: "cor",
    date: "data",
    datetime: "data e hora",
    "datetime-local": "data e hora - local",
    email: "email",
    month: "mês",
    number: "número",
    password: "senha",
    range: "intervalo",
    tel: "tel",
    text: "texto",
    time: "hora",
    url: "url",
    week: "semana",
    hidden: "oculto",
    on: "ligado",
    onPage: "na página",
    edit: "editar",
    display: "mostrar",
    onComplete: "ao completar",
    onHidden: "ao ocultar",
    all: "todos",
    page: "página",
    survey: "pesquisa",
    onNextPage: "na página seguinte",
    onValueChanged: "ao mudar valor"
  },
  //Operators
  op: {
    empty: "está vazio",
    notempty: "não está vazio",
    equal: "é igual",
    notequal: "não é igual",
    contains: "contém",
    notcontains: "não contém",
    greater: "maior",
    less: "menor",
    greaterorequal: "maior ou igual",
    lessorequal: "menor ou igual"
  },
  //Embed window
  ew: {
    angular: "Usar versão Angular",
    jquery: "Usar versão jQuery",
    knockout: "Usar versão Knockout",
    react: "Usar versão React",
    vue: "Usar versão Vue",
    bootstrap: "Para framework bootstrap",
    standard: "Sem bootstrap",
    showOnPage: "Mostrar pesquisa em uma página",
    showInWindow: "Mostrar pesquisa em uma janela",
    loadFromServer: "Carregar JSON da pesquisa de um servidor",
    titleScript: "Scripts e estilos",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  //Preview (Survey)
  ts: {
    selectPage: "Selecione a página para testar:",
    showInvisibleElements: "Mostrar elementos invisíveis"
  },
  validators: {
    answercountvalidator: "contador de respostas",
    emailvalidator: "e-mail",
    expressionvalidator: "expressão",
    numericvalidator: "numérico",
    regexvalidator: "regex",
    textvalidator: "texto"
  },
  triggers: {
    completetrigger: "completar pesquisa",
    setvaluetrigger: "definir valor",
    copyvaluetrigger: "copiar valor",
    runexpressiontrigger: "rodar expressão",
    visibletrigger: "alterar visibilidade"
  },
  //Properties
  p: {
    name: "nome",
    title: {
      name: "título",
      title: "Deixar vazio se for o mesmo que 'Nome'"
    },

    navigationButtonsVisibility: "Visibilidade dos botões de navegação",
    questionsOrder: "Ordenar elementos na página",
    maxTimeToFinish: "Tempo máximo para finalizar pesquisa",

    visible: "Visível?",
    visibleIf: "Visível se",
    questionTitleLocation: "Localização do título da pergunta",
    description: "Descrição",
    state: "Estado",
    isRequired: "Obrigatório?",
    requiredIf: "Obrigatório se",
    indent: "Indentação",
    requiredErrorText: "Texto de erro para obrigatório",
    startWithNewLine: "Começar com uma nova linha",
    innerIndent: "Indentação interna",
    page: "Página",

    width: "Largura",

    commentText: "Texto do comentário",
    valueName: "Nome do valor",
    enableIf: "Habilitar se",
    defaultValue: "Valor default",
    correctAnswer: "Resposta correta",
    readOnly: "Somente leitura",
    validators: "Validadores",
    titleLocation: "Localização do título",

    showCommentArea: "Tem comentário",
    showOtherItem: "Tem item 'outros'",
    choices: "Opções",
    choicesOrder: "Selecione a ordem das alternativas",
    choicesByUrl: "Opções com origem na Web",
    otherText: "Texto do item 'outros'",
    otherErrorText: "Texto de erro da opção 'outros'",
    storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",

    label: "Label",
    showTitle: "Mostrar título",
    valueTrue: "Valor verdadeiro",
    valueFalse: "Valor falso",

    cols: "Colunas",
    rows: "Linhas",

    optionsCaption: "Título das opções",

    expression: "Expressão",
    format: "Formato",
    displayStyle: "Mostrar estilo",
    currency: "Moeda",
    useGrouping: "Usar agrupamento",

    showPreview: "Mostrar preview",
    allowMultiple: "Permitir múltiplos",
    imageHeight: "Altura da imagem",
    imageWidth: "Largura da imagem",
    storeDataAsText: "Armazenar dados como texto",
    maxSize: "Tamanho máximo",

    html: "html",

    columns: "Colunas",
    cells: "Células",
    isAllRowRequired: "Todas linhas são obrigatórias",

    horizontalScroll: "Scroll horizontal",
    cellType: "Tipo de célula",
    columnsLayout: "Layout de colunas",
    columnColCount: "Contador de células de coluna",
    columnMinWidth: "Largura mínima da coluna",

    rowCount: "Contagem de linhas",
    minRowCount: "Contagem de linhas mínima",
    maxRowCount: "Contagem de linhas máxima",
    keyName: "Nome da chave",
    keyDuplicationError: "Erro de chave duplicada",
    confirmDelete: "Confirmar deleção",
    confirmDeleteText: "Texto de confirmar deleção",
    addRowLocation: "Localização do botão de adicionar linha",
    addRowText: "Texto do botão para adicionar linhas",
    removeRowText: "Texto do botão para remover linhas",

    items: "Itens",
    itemSize: "Tamanho do item",
    colCount: "Contagem de células",

    templateTitle: "Título do template",
    templateDescription: "Descrição do template",
    allowAddPanel: "Permitir adicionar painel",
    allowRemovePanel: "Permitir remover painel",
    panelCount: "Contador do painel",
    minPanelCount: "Contador do painel mínimo",
    maxPanelCount: "Contador do painel máximo",
    panelsState: "Estado dos painéis",
    panelAddText: "Texto de adicionar painel",
    panelRemoveText: "Texto de remover painel",
    panelPrevText: "Texto do painel anterior",
    panelNextText: "Texto do próximo painel",
    showQuestionNumbers: "Mostrar número das perguntas",
    showRangeInProgress: "showRangeInProgress",
    renderMode: "Modo de renderização",
    templateTitleLocation: "Localização do título do template",

    rateValues: "Valores de qualificação",
    rateMin: "Qualificação mínima",
    rateMax: "Qualificação máxima",
    rateStep: "Incremento da qualificação",
    minRateDescription: "Descrição de qualificação mínima",
    maxRateDescription: "Descrição de qualificação máxima",

    inputType: "Tipo de entrada",
    size: "Tamanho",

    locale: "Localidade",
    focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta",
    completedHtml: "Completo Html",
    completedBeforeHtml: "Completo Html antes",
    loadingHtml: "Carregando Html",
    triggers: "Triggers",
    cookieName: "Nome do cookie",
    sendResultOnPageNext: "Enviar resultado da pesquisa na página seguinte",
    showNavigationButtons: "Mostrar botões de navegação (navegação default)",
    showPrevButton: "Mostrar botão de voltar (usuário pode retornar para página anterior)",
    showPageTitles: "Mostrar título da página",
    showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
    showPageNumbers: "Mostrar número da página",
    questionErrorLocation: "Localização do erro da pergunta",
    showProgressBar: "Mostrar barra de progresso",
    mode: "Modo",
    goNextPageAutomatic: "Ao responder todas as perguntas, ir automaticamente para a próxima página",
    checkErrorsMode: "Modo de verificação de erros",
    clearInvisibleValues: "Limpar valores invisíveis",
    startSurveyText: "Texto para botão de começar",
    pagePrevText: "Texto para botão de página anterior",
    pageNextText: "Texto para botão de página seguinte",
    completeText: "Texto para botão de completar",
    requiredText: "Símbolo(s) para perguntas obrigatórias",
    questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
    questionTitleTemplate: "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
    firstPageIsStarted: "Primeira página da pesquisa é a página de início.",
    isSinglePage: "Mostrar todos elementos em uma página",
    maxTimeToFinishPage: "Tempo máximo para finalizar página da pesquisa",
    showTimerPanel: "Mostrar o painel de cronômetro",
    showTimerPanelMode: "Mostrar painel de modo de cronômetro",

    defaultPanelValue: "valor default do painel",
    defaultRowValue: "valor default da linha",
    showNoneItem: "não tem nenhum",
    noneText: "nenhum texto",

    text: "texto",
    minValue: "valor mínimo",
    maxValue: "valor máximo",
    minLength: "tamanho mínimo",
    maxLength: "tamanho máximo",
    allowDigits: "permitir dígitos",
    minCount: "contador mínimo",
    maxCount: "contador máximo",
    regex: "expressão regular"
  }
};

editorLocalization.locales["pt"] = portugueseTranslation;
